/* eslint-disable consistent-return */
/* global window */
/* eslint no-magic-numbers: "off" */

import Auth from '../app/Auth';
import { RECENT_SEARCHES } from 'Constants/localStorage';

const getKey = () => {
    const user = Auth.getUser();

    if (user && user.id) {
        return `${RECENT_SEARCHES.key}_${user.id}`;
    }
    return RECENT_SEARCHES.key;
};

const add = newSearch => {
    if (typeof window !== 'undefined' && window.localStorage && newSearch && newSearch.title) {
        newSearch.date = new Date().toDateString();
        const saved = window.localStorage.getItem(getKey());
        let recents = [];
        const title = newSearch.title;

        newSearch.title = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
        if (saved) {
            recents = JSON.parse(saved);
            // remove the search if search is already available, to correct the order
            const indexOfSearch = recents.findIndex(search => search.title === newSearch.title);

            if (indexOfSearch !== -1) {
                recents.splice(indexOfSearch, 1);
            }
            else if (recents.length === RECENT_SEARCHES.max) {
                recents.pop();
            }
            recents.unshift(newSearch);
        }
        else {
            recents.push(newSearch);
        }
        window.localStorage.setItem(getKey(), JSON.stringify(recents));
    }
};

const remove = removeSearch => {
    if (typeof window !== 'undefined' && window.localStorage && removeSearch) {
        const saved = window.localStorage.getItem(getKey()) || null;

        if (saved) {
            const updateRecentSearches = JSON.parse(saved)?.filter(item => item.title !== removeSearch);

            window.localStorage.setItem(getKey(), JSON.stringify(updateRecentSearches));
        }
    }
};

const get = () => {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            const saved = window.localStorage.getItem(getKey());

            const recentSearches = saved ? JSON.parse(saved) : [];

            // to remove recentSearches after 60 days
            const latestRecentSearches = recentSearches.filter(obj => {
                if (obj.date) {
                    const savedDate = new Date(obj.date);
                    const currentDate = new Date();
                    const dayMiliSec = 1000 * 60 * 60 * 24;

                    if (((currentDate - savedDate) / dayMiliSec) >= 60) {
                        remove(obj.title);
                        return;
                    }
                    return obj;
                }
                return obj;
            });

            return latestRecentSearches;
        }
        return [];
    }
    catch (e) {
        return [];
    }
};

export {
    add,
    get,
    getKey,
    remove
};
